/* tslint:disable:max-line-length */
import { TriangleWarningIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import css from './NeedsReviewAlert.module.css';

type Props = {
  className?: string;
  count?: number;
};

export const NeedsReviewAlert = ({ count, className }: Props) => {
  if ((count || 0) < 0) {
    return null;
  }
  return (
    <div className={classNames(className, css.container)}>
      <TriangleWarningIcon />
      <span className={css.text}>
        {count} {count === 1 ? 'Block Needs' : 'Blocks Need'} Review
      </span>
    </div>
  );
};
